import React from 'react';
import { fileName } from '../../../../utils/Constants';
import TermsAndConditions from '../steps/TermsAndConditions';

const OrderEatTermsAndConditionsStep = (props) => {
  return <TermsAndConditions {...props} fileName={fileName.OrderEatTC} />;
};

export default OrderEatTermsAndConditionsStep;
